import { CHANGE_PATH } from '../constants';

export default path => ({
  type: CHANGE_PATH,
  path
});



// WEBPACK FOOTER //
// ./src/actions/changePath.js